// extracted by mini-css-extract-plugin
module.exports = {"component":"liked-tracks_component_3yJVV","button":"liked-tracks_button_2lz1K","select-wrapper":"liked-tracks_select-wrapper_8IDW4","selected":"liked-tracks_selected_nMNwk"};